// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__FfNJd","list":"BalanceDue_list__vmSyO","listRow":"BalanceDue_listRow__KvYRO","total":"BalanceDue_total__3Lvc8"};